import axios from "./axios";

// Read receipts for the "Ny funksjon" dialog. Backend: /api/v1/feature_announcement_acknowledgements
// (one row per user + announcement key, first answer wins, no delete).

/** @returns {Promise<Array<{ key: string, response: string|null, acknowledged_at: string }>>} */
export async function fetchFeatureAnnouncementAcknowledgements() {
  const response = await axios.get("/feature_announcement_acknowledgements");
  const rows = response?.data?.data;
  if (!Array.isArray(rows)) throw new Error("feature_announcement_acknowledgements: unexpected payload");
  return rows;
}

/**
 * @param {string} key announcement key from the registry
 * @param {"dismissed"|"confirmed"|"switched_language"|"kept_language"} response
 */
export async function acknowledgeFeatureAnnouncement(key, response) {
  const result = await axios.post("/feature_announcement_acknowledgements", { key, response });
  return result?.data;
}
